import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { processSteps, techStack } from '../mock';

export const ProcessTabs = () => {
  const [active, setActive] = useState(processSteps[0].id);
  const current = processSteps.find((p) => p.id === active);
  return (
    <section id="process" className="py-20 bg-[#f6f7fb]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <h2 className="text-center text-[30px] md:text-[42px] font-bold text-slate-900">Our SaaS Development Process</h2>
        <p className="mt-4 text-center text-slate-600 max-w-3xl mx-auto">A proven approach, refined over 15+ years of shipping SaaS products — from discovery to long-term support.</p>
        <div className="flex flex-wrap justify-center gap-2 md:gap-3 mt-12">
          {processSteps.map((p) => (
            <button key={p.id} onClick={() => setActive(p.id)} className={`px-5 md:px-6 py-3 rounded-full text-sm font-semibold border transition-all ${active === p.id ? 'bg-[#E63946] text-white border-[#E63946] shadow-md' : 'bg-white text-slate-700 border-slate-200 hover:border-[#E63946] hover:text-[#E63946]'}`}>{p.label}</button>
          ))}
        </div>
        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="rounded-2xl overflow-hidden shadow-xl">
            <img src={current.img} alt={current.title} className="w-full h-[380px] object-cover" />
          </div>
          <div>
            <h3 className="text-[28px] md:text-[36px] font-bold text-slate-900 leading-tight">{current.title}</h3>
            <p className="mt-5 text-slate-600 leading-relaxed">{current.desc}</p>
            <Link to="/#contact" className="inline-block mt-8 bg-[#E63946] hover:bg-[#d02b38] text-white font-semibold px-7 py-3 rounded-full transition-colors">Get Started</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export const TechStackTabs = () => {
  const tabs = Object.keys(techStack);
  const [active, setActive] = useState(tabs[0]);
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <h2 className="text-center text-[30px] md:text-[42px] font-bold text-slate-900">Technologies We Use for SaaS Development</h2>
        <p className="mt-4 text-center text-slate-600 max-w-3xl mx-auto">We use the latest SaaS technology to build secure, scalable solutions that evolve with your business. As a trusted SaaS development agency, we ensure seamless SaaS integrations, enhancing efficiency and connectivity.</p>
        <div className="flex flex-wrap justify-center gap-2 md:gap-3 mt-10">
          {tabs.map((t) => (
            <button key={t} onClick={() => setActive(t)} className={`px-5 md:px-6 py-2.5 rounded-full text-sm font-semibold border transition-all ${active === t ? 'bg-[#E63946] text-white border-[#E63946]' : 'bg-white text-slate-700 border-slate-200 hover:border-[#E63946] hover:text-[#E63946]'}`}>{t === 'Front' ? 'Front End' : t === 'Back' ? 'Back-End' : t === 'Cloud' ? 'Cloud & DevOps' : t === 'Mobile' ? 'Mobile & PWA' : t === 'Testing' ? 'Testing & QA' : t}</button>
          ))}
        </div>
        <div className="mt-12 grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-6">
          {techStack[active].map((tech) => (
            <div key={tech.name} className="flex flex-col items-center gap-3 p-4 rounded-xl hover:bg-slate-50 hover:-translate-y-1 transition-all duration-300">
              <img src={tech.icon} alt={tech.name} className="w-14 h-14 object-contain" />
              <span className="text-xs text-slate-700 font-medium text-center">{tech.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
